module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAYklEQVR42u3WwQ3AIAxD0QwFdDSu2Th0glQMQC/IEUT+AzxfLcIY28jVFcvPFMvPOpY3L+TXfEXyg/wf38iv+QfJv/fxAQPREyNionHimImaYMKSTJQEE10EOQH+10iesUR9R6VxiAsIq9wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/left-carousel-arrow.png
// module id = kpGf
// module chunks = 0